import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  marginBottom: 28,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 29,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 40,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: 11,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 14,
  },
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));
